/* eslint-disable no-undef, class-methods-use-this */

import SelectorMapping from '../SelectorMapping';
import {
  getCurrentPageFromUrl,
  buildGoogleParamsHash,
  getGoogleParams,
} from '../utils';
import Events from '../events';
import options from '../options';

class PaginationHandler {
  googlePaginationMapping = new Map();

  pageCount = 0;

  get pages() {
    const paginationBtnSelector = SelectorMapping.get(
      'gsc-results__pagination-link',
    );
    const paginationBtns = document.querySelectorAll(paginationBtnSelector);
    this.pageCount = paginationBtns.length;

    return paginationBtns;
  }

  get currentPage() {
    return getCurrentPageFromUrl();
  }

  mapElementsToPageNumber() {
    this.googlePaginationMapping.clear();
    const { pages } = this;

    for (let i = 0; i < this.pageCount; i++) {
      const pageNumber = i + 1;
      this.googlePaginationMapping.set(pageNumber, pages[i]);
    }
  }

  setPagination() {
    this.mapElementsToPageNumber();
    this.buildButtons();
  }

  goToPage(pageNumber) {
    const currentParams = getGoogleParams();
    currentParams.page = pageNumber;

    const updatedHash = buildGoogleParamsHash(currentParams);

    window.location.hash = updatedHash;
  }

  handleClick(event) {
    event.preventDefault();

    const { currentTarget } = event;
    const targetPageNumber = parseInt(
      currentTarget.dataset.compPaginationTargetPage,
    );

    const googleSearchPaginationBtn = this.googlePaginationMapping.get(targetPageNumber);

    if (!googleSearchPaginationBtn) {
      return;
    }

    this.goToPage(targetPageNumber);
    window.scrollTo(0, 0);
    this.setPagination();
  }

  buildButtons() {
    const template = document.querySelector(
      'template.pagination-links-template',
    );
    const container = document.querySelector(
      '.pagination-links--gsc-pagination',
    );
    container.innerHTML = '';

    const [
      paginationContainer,
      linksContainer,
      previousPageBtn,
      pageBtn,
      nextPageBtn,
    ] = [...template.content.children].map((el) => el.cloneNode(true));

    const { currentPage, pages } = this;

    import('pagination').then((pagination) => {
      const paginationData = pagination
        .create('search', {
          current: currentPage,
          rowsPerPage: 10,
          totalResult: pages.length * 10,
        })
        .getPaginationData();

      const { previous, next, range } = paginationData;

      let buttons = range.map((pageNumber) => {
        const button = pageBtn.cloneNode();
        button.textContent = pageNumber;
        button.dataset.compPaginationTargetPage = pageNumber;

        if (currentPage === pageNumber) {
          button.classList.add('pagination-links__button--active');
        }

        button.setAttribute('aria-label', `Go to page ${pageNumber}`);
        return button;
      });

      if (previous) {
        previousPageBtn.dataset.compPaginationTargetPage = previous;
        buttons.unshift(previousPageBtn);
      }

      if (next) {
        nextPageBtn.dataset.compPaginationTargetPage = next;
        buttons.push(nextPageBtn);
      }

      buttons = buttons.map((button) => {
        const li = document.createElement('li');
        li.append(button);
        return li;
      });

      linksContainer.append(...buttons);
      paginationContainer.append(linksContainer);

      container.appendChild(paginationContainer);
      this.attachListeners();
    });
  }

  attachListeners() {
    const { selectors } = options;
    const paginationContainer = document.querySelector(
      selectors.paginationContainer,
    );
    const paginationButtons = paginationContainer.querySelectorAll(
      selectors.paginationButtons,
    );

    paginationButtons.forEach((buttonEl) => {
      buttonEl.addEventListener('click', (event) => this.handleClick(event));
    });
  }
}

export default PaginationHandler;
